<template>
  <div id="app">
    <div 
      id="open-menu" 
      :class="showMenuCta ? 'show' : ''"
      @click="() => toggleOpen(true)"
    >
      <div 
        class="circle-bg"
        :class="{ 'grey-circ' : isSectionWhite}"
      >
        
      </div>

      <img class="mobile" src="./assets/menu.svg" />
      <img class="desk" src="./assets/menu.svg" />
    </div>
    <Menu :toggleOpen="toggleOpen" />
    <transition name="slide-fade">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Menu from '@/components/Menu'
import {gsap, Power2} from 'gsap'

export default {
  components:{
    Menu
  },
  data(){
    return {
      isSectionWhite: false
    }
  },
  methods:{
    toggleOpen(val){
      var app = document.getElementById('app');
      
      app.style.minHeight = 'auto'
      gsap.fromTo('#menu', {x: val ? '100%' : '0%'}, {x: val  ? '0%' : '-100%', duration: .95, ease: 'Power2.easeInOut'})
    }
  },
  computed:{
    ...mapState({
      showMenuCta: state => state.showMenuCta
    })
  },
  watch: {
    '$route' (to, from) {
      this.isSectionWhite = to.name === 'Pyramid';
    }
  }
}
</script>

<style lang="scss">
*{
  margin: 0;
  padding: 0;
}

body{
  position: relative;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
#app {
  font-family: roc-grotesk,sans-serif;
  font-weight: 400;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}
#open-menu{
  position: fixed;
  z-index: 10;
  top: 40px;
  right: 30px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  @media screen and(max-width: 768px){
    top: 10px;
    right: 0;
    padding: 10px;
  }
  &.show{
    opacity: 1;
    visibility: visible;
    pointer-events: all;
    cursor: pointer;
  }
  transition: opacity .5s ease-in-out;
  &:hover{
    opacity: .6;
  }
  .circle-bg{
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba($color: #ffffff, $alpha: 0.50) ;;
    width: 250px;
    height: 250px;
    z-index: 2;
    border-radius: 50%;
    transform: translate(-15%, -65%);
    transition: background-color .2s;
    &.grey-circ{
      background-color: rgba($color: #1D1D1B, $alpha: 0.30) ;
    }
    @media screen and(max-width: 768px){
      width: 200px;
      height: 200px;
      transform: translate(-10%, -70%);
    }
  }
  img{
    position: relative;
    z-index: 3;
    display: block;
    &.mobile{
        display: none;
        @media screen and(max-width: 768px){
          display: block;
          width: 50px;
        }
      }
      &.desk{
        width: 80px;
        @media screen and(max-width: 768px){
          display: none;
        }
      }
  }
}
.compressed{
  font-family: roc-grotesk-compressed,sans-serif;
  font-weight: 400;
  font-style: normal;
}
.condensed{
  font-family: roc-grotesk-condensed,sans-serif;
  font-weight: 400;
  font-style: normal;
}
.condensed-bold{
  font-family: roc-grotesk-condensed, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.slide-fade-enter-active {
  transition: all .75s ease-in-out;
}
.slide-fade-leave-active {
  transition: all .75s ease-in-out;
}
.slide-fade-enter{
  transform: translateX(100%);
}
.slide-fade-leave-to{
  transform: translateX(-100%);
}
h2, h3, h4 {
  font-weight: normal;
}
</style>
